package org.braunequip.web.components.forms

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.braunequip.web.components.models.TimeOffRequestDTO
import org.braunequip.web.components.widgets.ConfirmModal
import org.braunequip.web.util.Constants.FONT_FAMILY
import org.braunequip.web.util.Constants.FONT_FAMILY2
import org.braunequip.web.util.InputIDs
import org.braunequip.web.util.Theme
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement

@Composable
fun AdminTimeOffForm(
    toUpdateTimeOff: TimeOffRequestDTO? = null,
    onSubmit: (TimeOffRequestDTO) -> Unit,
    onDismiss: () -> Unit
) {
    var showConfirmModal by remember { mutableStateOf(false) }
    var errorText by remember { mutableStateOf(" ") }
    var timeOffRequestState by remember(toUpdateTimeOff) {
        mutableStateOf(
            toUpdateTimeOff?.copy() ?: TimeOffRequestDTO()
        )
    }

    LaunchedEffect(Unit) {
        //TODO fill text areas
        //Necessary for loading default value, and having it still be editable.
        val timeOffDescription = (document.getElementById(InputIDs.TimeOffForm.message) as HTMLTextAreaElement)
        timeOffDescription.value = timeOffRequestState.description

        val timeOffPTOQuestion = (document.getElementById(InputIDs.TimeOffForm.usepto) as HTMLInputElement)
        timeOffPTOQuestion.checked = timeOffRequestState.usePtoQuestion
    }


    /* UI PART */
    Box(
        modifier = Modifier
            .width(100.vw)
            .height(100.vh)
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .zIndex(19),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .margin(top = 4.cssRem)
                .padding(1.cssRem)
                .zIndex(20)
                .width(min(500.px, 100.percent - 2.cssRem)),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Top
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {

                SpanText(
                    text = "ID: ${timeOffRequestState.id}",
                    modifier = Modifier
                        .fontSize(1.cssRem)
                        .fontFamily(FONT_FAMILY2)
                )


                FaX(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onDismiss()
                        }
                        .color(Colors.Grey)
                )
            }

            /*
                    Time off specific information here
             */
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(20.px)
            ) {
                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .id(InputIDs.TimeOffForm.firstname)
                        .fillMaxWidth()
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .toAttrs {
                            attr("placeholder", "First Name*")
                            attr("value", timeOffRequestState.employeeFirstName) // Set value from DTO
                        }
                )

                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .id(InputIDs.TimeOffForm.middlename)
                        .fillMaxWidth()
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .toAttrs {
                            attr("placeholder", "Middle Name")
                            attr("value", timeOffRequestState.employeeMiddleName) // Set value from DTO
                        }
                )

                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .id(InputIDs.TimeOffForm.lastname)
                        .fillMaxWidth()
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .toAttrs {
                            attr("placeholder", "Last Name*")
                            attr("value", timeOffRequestState.employeeLastName) // Set value from DTO
                        }
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .id(InputIDs.TimeOffForm.email)
                        .fillMaxWidth()
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .toAttrs {
                            attr("placeholder", "Email*")
                            attr("value", timeOffRequestState.employeeEmail) // Set value from DTO
                        }
                )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Input(
                    type = InputType.Text,
                    attrs = Modifier
                        .id(InputIDs.TimeOffForm.phone)
                        .fillMaxWidth()
                        .height(54.px)
                        .margin(topBottom = 12.px)
                        .padding(leftRight = 20.px)
                        .backgroundColor(Theme.LightGray.rgb)
                        .borderRadius(r = 4.px)
                        .border(
                            width = 1.px,
                            style = LineStyle.Solid,
                            color = Colors.Black
                        )
                        .fontFamily(FONT_FAMILY2)
                        .fontSize(16.px)
                        .toAttrs {
                            attr("placeholder", "Phone Number")
                            attr("value", timeOffRequestState.employeeContactNumber) // Set value from DTO
                        }
                )
            }

            HorizontalDivider(modifier = Modifier.fillMaxWidth().margin(topBottom = 1.cssRem))

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Start Date*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Date,
                        attrs = Modifier
                            .id(InputIDs.TimeOffForm.startdate)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                attr("value", timeOffRequestState.requestStartDate) // Set value from DTO
                            }
                    )
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "End Date*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Date,
                        attrs = Modifier
                            .id(InputIDs.TimeOffForm.enddate)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                attr("value", timeOffRequestState.requestEndDate) // Set value from DTO
                            }
                    )
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Return Date*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Date,
                        attrs = Modifier
                            .id(InputIDs.TimeOffForm.returndate)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                attr("value", timeOffRequestState.requestReturnDate) // Set value from DTO
                            }
                    )
                }
            }

            HorizontalDivider(modifier = Modifier.fillMaxWidth().margin(topBottom = 1.cssRem))

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    SpanText(
                        text = "Reason*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Text,
                        attrs = Modifier
                            .id(InputIDs.TimeOffForm.reason)
                            .fillMaxWidth()
                            .height(54.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs {
                                attr("placeholder", "ex. Vacation, Personal, Vacation, Sick, other")
                                attr("value", timeOffRequestState.reason) // Set value from DTO
                            }
                    )
                }
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        text = "Use PTO if available?*",
                        modifier = Modifier
                            .margin(right = 10.px)
                            .fontWeight(FontWeight.Bold)
                    )

                    Input(
                        type = InputType.Checkbox,
                        attrs = Modifier
                            .id(InputIDs.TimeOffForm.usepto)
                            .height(30.px)
                            .width(30.px)
                            .margin(topBottom = 12.px)
                            .padding(leftRight = 20.px)
                            .backgroundColor(Theme.LightGray.rgb)
                            .borderRadius(r = 4.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.Black
                            )
                            .fontFamily(FONT_FAMILY2)
                            .fontSize(16.px)
                            .toAttrs{
                                onInput { event ->
                                    timeOffRequestState.usePtoQuestion = event.value
                                }
                            }
                    )

                }
            }


            TextArea(
                attrs = Modifier
                    .id(InputIDs.TimeOffForm.message)
                    .fillMaxWidth()
                    .height(175.px)
                    .maxHeight(400.px)
                    .margin(top = 8.px)
                    .padding(all = 20.px)
                    .backgroundColor(Theme.LightGray.rgb)
                    .borderRadius(4.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(16.px)
                    .border(
                        width = 1.px,
                        style = LineStyle.Solid,
                        color = Colors.Black
                    )
                    .resize(Resize.None)
                    .toAttrs {
                        attr("placeholder", "Brief Description")
                        onInput { event ->
                            timeOffRequestState.description = event.value
                        }
                    }
            )

            SpanText(
                modifier = Modifier
                    .width(350.px)
                    .margin(top = 1.cssRem)
                    .fontFamily(FONT_FAMILY2)
                    .color(Colors.Black)
                    .textAlign(TextAlign.Center),
                text = errorText
            )


            SubmitButton(
                text = "SUBMIT",
                onClick = {
                    timeOffRequestState = timeOffRequestState.copy(
                        employeeFirstName = (document.getElementById(InputIDs.TimeOffForm.firstname) as HTMLInputElement).value,
                        employeeMiddleName = (document.getElementById(InputIDs.TimeOffForm.middlename) as HTMLInputElement).value,
                        employeeLastName = (document.getElementById(InputIDs.TimeOffForm.lastname) as HTMLInputElement).value,
                        employeeEmail = (document.getElementById(InputIDs.TimeOffForm.email) as HTMLInputElement).value,
                        employeeContactNumber = (document.getElementById(InputIDs.TimeOffForm.phone) as HTMLInputElement).value,
                        requestStartDate = (document.getElementById(InputIDs.TimeOffForm.startdate) as HTMLInputElement).value,
                        requestEndDate = (document.getElementById(InputIDs.TimeOffForm.enddate) as HTMLInputElement).value,
                        requestReturnDate = (document.getElementById(InputIDs.TimeOffForm.returndate) as HTMLInputElement).value,
                        reason = (document.getElementById(InputIDs.TimeOffForm.reason) as HTMLInputElement).value,
                        usePtoQuestion = (document.getElementById(InputIDs.TimeOffForm.usepto) as HTMLInputElement).checked,
                        description = (document.getElementById(InputIDs.TimeOffForm.message) as HTMLTextAreaElement).value,
                    )

                    if (
                        timeOffRequestState.employeeFirstName.isNotEmpty() &&
                        timeOffRequestState.employeeLastName.isNotEmpty() &&
                        timeOffRequestState.employeeEmail.isNotEmpty() &&
                        timeOffRequestState.requestStartDate.isNotEmpty() &&
                        timeOffRequestState.requestEndDate.isNotEmpty() &&
                        timeOffRequestState.requestReturnDate.isNotEmpty() &&
                        timeOffRequestState.reason.isNotEmpty()
                    ) {
                        showConfirmModal = true
                    } else {
                        errorText = "Please fill out all required fields."
                    }

                }
            )

            if (showConfirmModal) {
                ConfirmModal(
                    actionText = "Update Time Off Request",
                    onConfirm = {
                        errorText = "Submitted!"
                        onSubmit(timeOffRequestState)
                        showConfirmModal = false
                    },
                    onDismiss = {
                        showConfirmModal = false
                    }
                )
            }


        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundColor(Theme.DarkerGray.rgb)
                .position(Position.Fixed)
                .padding(top = 5.cssRem)
                .onClick {
                    onDismiss()
                }
                .zIndex(19),
            contentAlignment = Alignment.TopCenter
        )
    }
}